import Cookies from "js-cookie";
import { hasImpersonationSession } from "@/lib/authCookies";

export function isImpersonating() {
  return hasImpersonationSession();
}

export function getPartnerAuthHeaders() {
  const token = Cookies.get("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function getClientAuthToken() {
  return Cookies.get("impersonation_token") || Cookies.get("token") || "";
}

export function getClientAuthHeaders() {
  const token = getClientAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
